<agpr-take-over-panel
    [id]="id"
    header="Briefings.manageTemplates"
    (visibleChange)="cancel()"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    [responsiveWidth]="true"
    [minPanelWidth]="700"
    [maxPanelWidth]="1000"
>
    <div class="agpr-manage-templates-content">
        <agpr-table
            [id]="id + '_table'"
            class="agpr-manage-templates-table"
            [columns]="templateColumnDefs"
            [sortColumn]="primaryColumnDef"
            [sortAscending]="true"
            [showDelete]="true"
            [deleteLabel]="'Briefings.templateManageDialog.deleteTemplate' | localize"
            [(ngModel)]="templateRows"
            (ngModelChange)="checkForSelected()"
            (itemChanged)="updateTemplate($event)"
            (itemDelete)="deleteTemplate($event)"
            [agprLoading]="tableLoading"
        ></agpr-table>
    </div>

    <ng-template #takeOverFooterRight>
        <agpr-button
            [id]="id + '_deleteButton'"
            [disabled]="!hasSelectedTemplates"
            label="delete"
            [style]="buttonTypes.primaryB"
            (click)="deleteSelectedTemplates()"
        ></agpr-button>
        <agpr-button
            [id]="id + '_doneButton'"
            label="done"
            [style]="buttonTypes.primary"
            (click)="hideSlideOverlay = true"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
